// extracted by mini-css-extract-plugin
module.exports = {"lia-message-contributors-count":"MessageContributors_lia-message-contributors-count__Hwywn"};